import React, { Fragment } from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AttachMoney from "@material-ui/icons/AttachMoney";
import InfoSplit from "../InfoSplit.js";

const PageFive = ({
  joinFee,
  setJoinFee,
  firstPlacePrize,
  setFirstPlacePrize,
  secondPlacePrize,
  setSecondPlacePrize,
  thirdPlacePrize,
  setThirdPlacePrize,
  percentCut,
  setPercentCut,
  error,
  errorMessage,
  splitType, 
  setSplitType,
}) => {
  const handleSplit = (e) => {
    setSplitType(e.target.value);
    if (e.target.value === "Gold") setPercentCut(80);
    else if (e.target.value === "Silver") setPercentCut(50);
    else setPercentCut(20);
  };
  return (
    <Fragment>
      <Typography className="createLeagueFieldText">
        How much will it cost to join your league?
      </Typography>
      <Typography className="createLeagueFieldSubtext">Join Fee</Typography>
      <TextField
        value={joinFee}
        required
        placeholder="0.00"
        onChange={(e) => setJoinFee(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AttachMoney />
            </InputAdornment>
          ),
        }}
      />
      <Typography className="createLeagueFieldText margin20Top">
        Define the prize pools
      </Typography>
      <div className="rowCenter">
        <div className="widthThird margin10Right">
          <Typography className="createLeagueFieldSubtext">
            First Place
          </Typography>
          <TextField
            required
            fullWidth
            value={firstPlacePrize}
            placeholder="0.00"
            onChange={(e) => setFirstPlacePrize(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="widthThird margin10Horizontal">
          <Typography className="createLeagueFieldSubtext">
            Second Place
          </Typography>
          <TextField
            required
            fullWidth
            value={secondPlacePrize}
            placeholder="0.00"
            onChange={(e) => setSecondPlacePrize(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="widthThird margin10Left">
          <Typography className="createLeagueFieldSubtext">
            Third Place
          </Typography>
          <TextField
            required
            fullWidth
            value={thirdPlacePrize}
            placeholder="0.00"
            onChange={(e) => setThirdPlacePrize(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
     <div className="row posRelative" style={{display:"none"}} >
        <Typography className="createLeagueFieldText margin20Top">
          Proposed split of earnings
        </Typography>
        <InfoSplit />
      </div>
      <div className="maxWidth" style={{display:"none"}}>
        <RadioGroup value={splitType} onChange={handleSplit}>
          <FormControlLabel
            className="scoreUploadRadioText"
            value="Gold"
            control={<Radio color="default" />}
            label="Gold Split (Director 80%, Platform 20%)"
            labelPlacement="end"
          />
          <FormControlLabel
            value="Silver"
            className="scoreUploadRadioText"
            control={<Radio color="default" />}
            label="Silver Split (Director 50%, Platform 50%)"
            labelPlacement="end"
          />
          <FormControlLabel
            value="Bronze"
            className="scoreUploadRadioText"
            control={<Radio color="default" />}
            label="Bronze Split (Director 20%, Platform 80%)"
            labelPlacement="end"
          />
        </RadioGroup>
      </div>
      <div className="heightPlaceholder">
        {error && (
          <Typography className="createLeagueErrorText">
            {errorMessage}
          </Typography>
        )}
      </div>
    </Fragment>
  );
};

export default PageFive;
